import * as Sentry from '@sentry/react';
import {
  CHAT_SLICE_NAME,
  CONFIG_SLICE_NAME,
  RESULTS_SLICE_NAME,
  SPECIALTIES_SLICE_NAME,
} from 'store/slices/slicesNames';

import { actions } from 'store/toolkit';

const actionsToIgnore = new Set([
  actions.results.setHoveredResult.toString(),
  actions.results.clearHoveredResult.toString(),
  actions.map.moved.toString(),
]);

/**
 * functions for each slice that determine which values to include in the Sentry json file that is attached on errors
 */
const sliceTransformers = {
  [CONFIG_SLICE_NAME]: ({ values, ...rest }) => rest,
  [SPECIALTIES_SLICE_NAME]: ({ specialties, subspecialties, ...rest }) => rest,
  [CHAT_SLICE_NAME]: ({ conversation, ...rest }) => rest,
  [RESULTS_SLICE_NAME]: ({ response: { results, ...restResponse }, ...resultsSlice }) => ({
    ...resultsSlice,
    response: restResponse,
  }),
};

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // https://docs.sentry.io/platforms/javascript/guides/react/features/redux/#redux-enhancer-options
  actionTransformer: ({ type, meta }) => {
    if (actionsToIgnore.has(type)) return null;
    return { type, meta }; // for now, ignore the payload to avoid sending too much data. Update this as necessary
  },

  stateTransformer: (state) => {
    const transformedState = { ...state };

    Object.entries(sliceTransformers).forEach(([sliceName, transformer]) => {
      transformedState[sliceName] = transformer(state[sliceName]);
    });

    return transformedState;
  },
});

export default sentryReduxEnhancer;
